import React from 'react';

/**
 * Szegmentált kapcsoló. A kijelölt fül tömör brand-lapot kap, a többi
 * áttetsző marad — így egy pillantásra látszik, melyik az aktív.
 */
export default function FilterTabs({ filters, current, onChange }) {
  return (
    <div className="inline-flex flex-wrap items-center gap-1 p-1 rounded-xl
                    bg-black/25 border border-white/[0.07]">
      {filters.map(f => {
        const active = current === f.id;
        return (
          <button
            key={f.id}
            onClick={() => onChange(f.id)}
            className={`font-mono text-xs px-3 h-[30px] rounded transition-colors duration-150 ${
              active
                ? 'bg-[#23262b] text-white border border-line-strong'
                : 'text-gray-400 hover:text-white hover:bg-[#181a1e] border border-line'
            }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
